import React from 'react';

const ImprintIcon: React.FC = () => (
  <svg
    width="9"
    height="20"
    viewBox="0 0 9 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.0965 2.76952C5.76978 1.1572 1.83878 1.41725 1.83878 3.83573C1.83878 6.25421 2.89523 5.94215 4.78703 7.24241C6.67883 8.54267 8.61976 9.37483 7.44046 11.2732C6.26116 13.1716 4.98358 12.5475 3.92712 12.6775"
      stroke="#00223C"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M1.2 17.4108C2.55128 18.7371 7.31763 18.6071 7.29306 16.1886C7.29306 14.7843 6.38401 14.0041 4.19739 12.8079C2.01077 11.6117 1.37198 11.2216 1.37198 9.66128C1.37198 8.10097 3.82886 7.37283 4.78704 7.2168"
      stroke="#00223C"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default ImprintIcon;
